"use strict";

var browser, os, WW, WH, DH, ST, baseURL, lazy, minW = 320, resizeTo, lang, doc = 'document,html,body', base = ($('base').length ? $('base').attr('href') : $('html').data('base')), lang = $('html').attr('lang'), d = false, previousTop = 0, opened = 0, running, bd = $('.backdrop'), navbarHover = 0, lastScrollTop = '', justEmpty = '', scrolldown = 0, basketPageAppend = 0, running = false, triggered = 0, targetYTID = '', triggeredVimeo = 0, targetVimeoID = '';
browser = getBrowser();
os = getOS();

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};

$('.btn-anim').mousemove(function (e) {
    var x = e.pageX - $(e.currentTarget).offset().left,
        y = e.pageY - $(e.currentTarget).offset().top;

    $(e.currentTarget).find('span.bg').css({
        'left': x,
        'top': y
    });
});

$(document).ready(function () {
    lang = $('html').attr('lang');
    baseURL = $('base').attr('href');
    $('html').addClass('br_' + browser).addClass('os_' + os);

    resize();

    if (document.fonts && document.fonts.ready && $('.creator__item-header-text').length) {
        document.fonts.ready.then(function () {
            fitTextToBox('.creator__item-header-text');
        });
    }

    $(window).resize(function () {
        clearTimeout(resizeTo);
        resizeTo = setTimeout(function () {
            resize();
        }, 400);
    });

    scroll();
    $(window).scroll(function () {
        scroll();
    });

    $('body').on('click', 'a', function () {
        var href = $(this).attr('href');

        if (href.indexOf('#') != -1) {
            var id = href.substr(href.indexOf('#'));
            if ($(id).length) {
                $(doc).animate({'scrollTop': $(id).offset().top - $('.navbar').height() - 60}, 'slow');

                return false;
            }
        }
    });

    WIaccessibility();
    popup();
    menu();
    submenu();
    backdrop();
    pageSettings();

    if ($('.form-group').length) {
        form();
    }

    if ($('.datepicker').length) {
        datepicker();
        $('.datepicker').each(function (i, v) {
            $(v).inputmask('9{4}. 9{2}. 9{2}.');
        });
    }

    if ($('.form-tax').length) {
        var taxFormat = $('.form-tax').data('taxformat');
        $('.form-tax').inputmask(taxFormat);
    }

    if ($('textarea:not(.form-editor)').length) {
        autosize($('textarea:not(.form-editor)'));
    }

    if ($('.input-urls').length) {
        addUrl();
    }

    if ($('input[type=password]').length) {
        passwordChecker();
    }

    if ($('.input-group-code').length) {
        inputFocus();
    }

    if ($('.input-copy').length) {
        copyValue();
    }

    if ($('.input-check').length) {
        checkInputContent();
        focusInputContent();
    }

    if ($('.input-barion').length) {
        $('.input-barion').mask('000 000 000');
    }

    if ($('.page-dashboard').length) {
        pageDashboard();
        dashboardSlider();
    }

    if ($('.page-settings').length || $('.page__support').length) {
        deleteAddedUrl();

    }

    if ($('.page-help').length) {
        accordion();
    }

    if ($('.page-compare-v2').length) {
        pageCompare();
    }

    if ($('.page-donations').length) {
        pageDonations();
    }

    if ($('.fanpage-donations-slider').length) {
        donationSlider();
    }

    if ($('.create-notification').length) {
        $('.create-notification').off().on('click', function (e) {
            e.preventDefault();

            var self = $(this),
                textToNoti = $(self).data('text');

            $(self).addClass('disable');

            createNotification(textToNoti, $(this));


            return false;
        });
    }

    if ($('.tab-other-billing').length) {
        paywallBilling();
    }

    closeNotification();

    if ($('.tooltip-trigger').length) {
        tooltip();
    }

    if ($('#organization').length) {
    }

    if ($('.page-fanpage').length) {
        fanpageDonationList();
        fanpageDescription();
        showFanpageShare();
    }

    if ($('.post-list').length) {
        postVideoEmbed();
        postVideoThumbnail();
        postList();

    }

    if ($('.fanpage-posts').length) {
    }

    if ($('.page-readpost').length) {
        postVideoEmbed();
        if ($('.page-readpost .music-player').length) {
            audioplayer();
        }

        readpostComment();
    }

    if ($('.page-writepost').length) {
        writePost();
        writePostSend();
        dzAudioURL();
    }

    if ($('.page-donations').length && $('#osszespwadomanyozott').length) {
        $('#osszespwadomanyozott').appendTo($('#osszespwadomanyozott').siblings('.donation-container'));
    }

    if ($('.page-registration-step1').length) {
        $('#additional-settings').click(function () {
            $('.profil-additional-settings').slideToggle();
        });

        donationPage();
    }

    if ($('.js-showcustomblock').length) {
        showCustomBlock();
    }

    if ($('.readpost-donation-showmore').length) {
        pageReadPost();
    }

    if ($('[data-fancybox]').length) {
        postGallery();
    }


    if ($('.page-message').length) {
        pageSendMessage();
        sendMessage();
    }

    setTimeout(function () {
        $('html').addClass('page-loaded');
    }, 500);
});

function scroll() {
    WW = $(window).width();
    ST = $(window).scrollTop();

    animateScroll();

    if (ST < previousTop) {

        if (ST > 0) {
        } else {

        }

        if ($('.page-writepost').length) {
            if (ST <= ($('.writty-editor').offset().top + $('.writty-editor').outerHeight() - ($('.navbar').outerHeight() + 50)) && $('.writty-editor').outerHeight() >= 150) {
                $('.page-writepost').addClass('float-toolbar');
            }

            if ((ST + $('.navbar').outerHeight() + 5) <= $('.writty-content').offset().top) {
                $('.page-writepost').removeClass('float-toolbar');
            }
        }
    } else {
        var cat = $('.header-slider').height();

        if (ST > previousTop && ST > cat && !d) {
            $('html').addClass('scrolled-down');

            lastScrollTop = ST;

            if (scrolldown == 0) {
                setTimeout(function () {
                    $(window).scrollTop($(window).scrollTop() + 1);
                    scrolldown = 1;
                }, 100);
            }
        }

        if ($('.page-writepost').length) {
            if ((ST + $('.navbar').outerHeight() + 5) >= $('.toolbar').offset().top && $('.writty-editor').outerHeight() >= 150) {
                $('.page-writepost').addClass('float-toolbar');
            }
            if (ST >= ($('.writty-editor').offset().top + $('.writty-editor').outerHeight() - ($('.navbar').outerHeight() + 50))) {
                $('.page-writepost').removeClass('float-toolbar');
            }
        }
    }

    previousTop = ST;

    $('.parallaxbg').each(function () {
        var top = $(this).offset().top;
        var h = $(this).outerHeight(true);
        if ((top - WH) < ST && (top + h) > ST) {
            $(this).css('background-position', 'center ' + ((ST - top) * 0.3) + 'px');
        }
    });
}

let mobilSize = 0, submenuOpen = 0, menuLink = 'javascript:void(0)';
let slickGoto = false;
let classChangeDiv = $('.navbar__menu-change');
let classChangeDesktop = classChangeDiv.data('desktop');
let classChangeMobil = classChangeDiv.data('mobil');

function resize() {
    WW = $(window).width();
    WH = $(window).height();
    DH = $(document).height();


    if ($('.page__tariff').length) {
        resizeBoxes('.pt__title');
        resizeBoxes('.pt__desc');
    }

    if (WW <= 575) {
        if ($('.fanpage-box-v2').length) {
            fanpageMobil();
        }
    } else {
        $('.fanpage-box-v2 .fanpage-box-inner').removeAttr('style');
    }

    if (WW <= 768) {
        if ($('.services-item').length) {
            $('.services-item p').removeAttr('style');
        }

        let checkSliderInterval = setInterval(function () {
            if ($('.fanpage-donations-slider').length && $('.fanpage-donations-slider').hasClass('slick-initialized') && !slickGoto) {

                $('.fanpage-donations-slider').slick('slickGoTo', 1);
                slickGoto = true;
                clearInterval(checkSliderInterval);
            }
        }, 10);
    } else {
        if ($('.services-item').length) {
            resizeBoxes('.services-item p');
        }
    }

    if (WW <= 992) {
        if ($('.donation-container').length) {
            $('.donation-container .right p.name').removeAttr('style');
        }

        if ($('.page-tariff').length) {
            $('.page-tariff .tariff-title').removeAttr('style');
        }

        if ($('.recommender').length) {
            $('.recommender-title').removeAttr('style');
        }

        if ($('.creator-slider').length) {
            if ($('.creator-slider').hasClass('slick-initialized')) {
                $('.creator-slider').slick('unslick');
            }

            fitTextToBox('.creator__item-header-text');
        }

        classChangeDiv.removeClass('submenu submenu-general').addClass(classChangeMobil);

    } else {
        classChangeDiv.removeClass('navbar__nav-submenu').addClass(classChangeDesktop);

        if ($('.donation-container').length) {
            resizeBoxes('.donation-container .right p.name');
        }

        if ($('.page-tariff').length) {
            resizeBoxes('.page-tariff .tariff-title');
        }

        if ($('.recommender').length) {
            resizeBoxes('.recommender-title');
        }

        if ($('.creator-slider').length && !$('.creator-slider').hasClass('slick-initialized')) {
            cretorSlider();
        }
    }
}
